var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoading
    ? _c("div", [_vm._v("Loading Please wait...")])
    : _vm.list.length === 0
    ? _c("div", [
        _c("span", [
          _vm._v("No Licenses Specified, yet. Click Add to create one."),
        ]),
      ])
    : _c(
        "div",
        [
          _c("div", { staticStyle: { height: "28px", "margin-top": "10px" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: this.showDeleteButton > 0,
                    expression: "this.showDeleteButton > 0",
                  },
                ],
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "5px" },
                    attrs: { type: "secondary", size: "mini", plain: "" },
                    on: { click: _vm.handleDeleteSelected },
                  },
                  [
                    _vm._v(
                      "Remove " +
                        _vm._s(this.showDeleteButton) +
                        " Selected License(s)? "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isLoading,
                  expression: "isLoading",
                },
              ],
              ref: "vendorLicensesTable",
              staticStyle: { width: "100%" },
              attrs: {
                id: "vendor-licenses-table",
                "row-key": "vendorLicenseId",
                data: _vm.list,
                fit: "",
                size: "small",
                "max-height": "400px",
                "highlight-current-row": "",
              },
              on: {
                "row-click": _vm.handleEditRow,
                "selection-change": _vm.handleSelectionChange,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  "reserve-selection": true,
                  align: "center",
                  width: "55",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "License Type" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(" " + _vm._s(row.licenseType.name) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "License Number" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("uppercase")(row.licenseNumber))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { width: "110", label: "State" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm._f("uppercase")(row.state))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Expiration Date", sortable: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("parseUtc")(row.expirationDate)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }